export const DEFAULT_THEMES: string[] = [
  '#3f51b5',
  '#4156ee',
  '#2196f3',
  '#03a9f4',
  '#00bcd4',
  '#009688',
  '#4caf50',
  '#8bc34a',
  '#cddc39',
  '#ffeb3b',
  '#ffc107',
  '#ff9800',
  '#ff5100',
  '#ff5722',
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#8066a7',
  '#607d8b',
  '#9e9e9e',
  '#795548',
];
